import { Log, LogCategory, Operation as LogOperation } from '@augloop/logging';
export class WorkflowItemStorage {
    constructor(workflowDefinitionManager) {
        this.scopeItemsByContextId = new Map();
        this.itemsByWorkflowAndContextId = new Map();
        this.workflowDefinitionManager = workflowDefinitionManager;
    }
    setScopeItem(scopeItem, workflow) {
        var _a;
        const contextId = scopeItem.contextId;
        if (!contextId) {
            return;
        }
        if (!this.itemsByWorkflowAndContextId.has(workflow.id)) {
            this.itemsByWorkflowAndContextId.set(workflow.id, new Map());
        }
        this.itemsByWorkflowAndContextId.get(workflow.id).set(contextId, []);
        if (!this.scopeItemsByContextId.has(contextId)) {
            this.scopeItemsByContextId.set(contextId, scopeItem);
        }
        else {
            if ((_a = this.itemsByWorkflowAndContextId.get(workflow.id)) === null || _a === void 0 ? void 0 : _a.has(contextId)) {
                const logOp = new LogOperation({
                    resultDescription: `Trying to set new scope item: ${scopeItem.id} with already existing contextId ${contextId} for workflow ${workflow.id}`,
                    operationName: 'WIS.setScopeItem',
                    resourceId: workflow.id,
                    success: true
                }).start();
                Log.verbose(0x1f6dd398 /* tag_513oy */, LogCategory.CoreDefault, logOp.stop());
            }
        }
    }
    getScopeItem(contextId, workflow) {
        var _a;
        for (const scopeContextId of ((_a = this.itemsByWorkflowAndContextId.get(workflow.id)) === null || _a === void 0 ? void 0 : _a.keys()) || []) {
            if (contextId.startsWith(scopeContextId)) {
                return this.scopeItemsByContextId.get(scopeContextId);
            }
        }
        // This contextId belongs to a different join workflow execution, so no scope item for this execution
        return undefined;
    }
    addItemToWorkflowList(item, workflow) {
        const itemContextId = item.contextId;
        if (!itemContextId) {
            return;
        }
        const itemsByContextId = this.itemsByWorkflowAndContextId.get(workflow.id);
        if (itemsByContextId) {
            for (const [scopeContextId, itemsList] of itemsByContextId) {
                if (itemContextId.startsWith(scopeContextId)) {
                    itemsList.push(item);
                    const logOp = new LogOperation({
                        resultDescription: `Items for contextId ${scopeContextId}: [${itemsList.map(item => item.id).join(',')}]`,
                        operationName: 'WIS.addItemOnContextIdList',
                        resourceId: workflow.id,
                        success: true
                    }).start();
                    Log.info(0x1f6048e0 /* tag_5ye96 */, LogCategory.CoreDefault, logOp.stop());
                }
            }
        }
    }
    isWorkflowReady(contextId, workflow) {
        const maxAnnotations = this.workflowDefinitionManager.getWorkflowDefinition(workflow, contextId).maxAnnotations;
        return this.getGeneratedItems(contextId, workflow).length >= maxAnnotations;
    }
    getItemsToExecute(contextId, workflow) {
        const items = this.getGeneratedItems(contextId, workflow);
        this.itemsByWorkflowAndContextId.get(workflow.id).delete(contextId);
        return items;
    }
    onWorkflowExecuted(scopeItem, workflow) {
        const contextId = scopeItem.contextId;
        // delete annotation list of the current workflow executed
        const itemsByContextId = this.itemsByWorkflowAndContextId.get(workflow.id);
        if (itemsByContextId) {
            itemsByContextId.delete(contextId);
            if (itemsByContextId.size === 0) {
                this.itemsByWorkflowAndContextId.delete(workflow.id);
            }
        }
        // delete scope item if there isn't any workflow waiting for
        // an execution with this contextId
        if (!this.hasWorkflowsAwaitingExecution(contextId)) {
            this.scopeItemsByContextId.delete(contextId);
        }
    }
    getGeneratedItems(contextId, workflow) {
        var _a;
        if (!((_a = this.itemsByWorkflowAndContextId.get(workflow.id)) === null || _a === void 0 ? void 0 : _a.get(contextId))) {
            return [];
        }
        const maxAnnotations = this.workflowDefinitionManager.getWorkflowDefinition(workflow, contextId).maxAnnotations;
        return this.itemsByWorkflowAndContextId.get(workflow.id).get(contextId).slice(0, maxAnnotations);
    }
    hasWorkflowsAwaitingExecution(contextId) {
        for (const itemsByContextId of this.itemsByWorkflowAndContextId.values()) {
            for (const scopeContextId of itemsByContextId.keys()) {
                if (scopeContextId === contextId) {
                    return true;
                }
            }
        }
        return false;
    }
}
//# sourceMappingURL=workflow-item-storage.js.map